module.exports = __webpack_public_path__ + "img/ruffle length.293f5834.png";